<template>
    <Modal
        @hide="emit('hide')"
        :width="emailSend ? 840 : 1463"
    >
        <!-- Email save -->
        <div v-show="!deviceError">
            <div class="row" v-show="!emailSend">
                <div class="col-md-5 conf2-save-image">

                </div>
                <div class="col-md-7">
                    <div class="conf2-save-right">
                        <h4>{{ t('conf2-save-ar-view-headline') }}</h4>
                        <p v-html="t('conf2-save-ar-text')"></p>
                        <div class="form-group">
                            <label>{{ t('form-email') }}</label>
                            <input class="form-control" type="email" v-model="email" name="email"
                                   :placeholder="t('form-email-placeholder')"
                                   @input="emailError = false">
                            <div class="error" v-if="emailError">
                                <p>{{ t('conf2-special_wish-email-error') }}</p>
                            </div>
                        </div>
                        <div class="form-group agb">
                            <div class="checkbox-wrapper">
                                <input
                                    class="checkbox"
                                    type="checkbox"
                                    value=""
                                    v-model="newsletter"
                                    @change="newsletterError = false"
                                    id="conf2-ar-checkbox-accept"
                                >
                                <label
                                    class="checkbox-label"
                                    for="conf2-ar-checkbox-accept"
                                    v-html="t('conf2-newsletter-checkbox')"
                                ></label>
                            </div>
                            <div class="error" v-if="newsletterError">
                                <p>{{ t('conf2-newsletter-checkbox-error') }}</p>
                            </div>
                        </div>

                        <button class="btn btn-primary conf2-redesign" @click="sendEmailHandler">
                            {{ t('conf2-save-ar-send') }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- AR QR Code -->
            <div v-show="emailSend">
                <div class="conf2-save-right">
                    <p class="text-center qr-text">{{ t('conf2-qr-ar-text') }}</p>
                    <div class="conf2-qr-code" ref="qrcode1"></div>
                </div>
            </div>
        </div>
        <div v-show="deviceError">
            <div class="device-error">
                <h4>{{ t('conf2-ar-device-error-heading') }}</h4>
                <div class="clearfix">
                    <div class="conf2-qr-code pull-left" ref="qrcode2"></div>
                    <p class="pull-left">{{ t('conf2-ar-device-error-text') }}</p>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import Modal from './Modal.vue';
import * as QRCode from 'easyqrcodejs';

const {t} = useI18n();

const emit = defineEmits<{
    hide: [];
    sendEmail: [payload: { email: string; newsletter: boolean; done: (href: string) => void }];
}>();

const email = ref(window.customerAuth?.isAuthenticated ? (window.customerAuth.email ?? '') : '');
const emailError = ref(false);
const deviceError = ref(false);
const emailSend = ref(false);
const newsletter = ref(false);
const newsletterError = ref(false);
const qrcode1 = ref<HTMLElement | null>(null);
const qrcode2 = ref<HTMLElement | null>(null);

watch(newsletter, (newValue) => {
    if (newValue) {
        newsletterError.value = false;
    }
});

const showQRCode = (href: string, width = 500, height = 500) => {
    const options = {
        correctLevel: QRCode.CorrectLevel.H,
        text: href,
        logo: "/gfx/conf2/loader/bird-black-gap.png",
        width: width,
        height: height,
        logoWidth: width / 2.63,
        logoHeight: height / 2.63,
    };

    // Create new QRCode Object
    if (qrcode1.value) {
        new QRCode.default(qrcode1.value, options);
    }
    if (qrcode2.value) {
        new QRCode.default(qrcode2.value, options);
    }
};

const sendEmailHandler = () => {
    emailError.value = !isEmailValid(email.value);

    newsletterError.value = !newsletter.value;

    if (emailError.value || newsletterError.value) {
        return false;
    }

    emit('sendEmail', {
        email: email.value,
        newsletter: newsletter.value,
        done: (href: string) => {
            showQRCode(href);
            emailSend.value = true;
        },
    });
};

const isEmailValid = (emailValue: string): boolean => {
    return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(emailValue);
};
</script>

<style scoped lang="scss">
.modal-mask .modal-right {
    font-size: 15px;

    .form-group {
        margin-bottom: 10px;
    }

    h4 {
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 500;
        margin-bottom: 30px;

        .is-responsive & {
            font-size: 19px;
            margin-bottom: 10px;
        }
    }

    input.form-control {
        height: 42px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16);
        -webkit-appearance: none;
        border: none;
        background: white;
        text-transform: uppercase;
        width: 75%;
    }
}

#configurator .row .btn-primary {
    color: black !important;
    background: #FFDA60 !important;
    border-radius: 0 !important;
    padding: 10px 20px !important;
    font-size: 1.1em !important;

    &:hover {
        background: darken(#FFDA60, 10%) !important;
    }
}

.conf2-qr-code {
    padding: 0 0 50px;
    text-align: center;
}

.url {
    max-width: 100%;
    display: inline-block;
    text-overflow: ellipsis;
    overflow-x: hidden;
    vertical-align: bottom;
}

.error {
    p {
        color: red;
        margin-bottom: 5px;
    }
}

.conf2-radio-wrapper {
    margin-bottom: 12px;

    div {
        margin-bottom: 2px;
    }

    span {
        font-size: 13px;
        line-height: 1.5;
        display: block;
        float: left;
        padding-left: 35px;
        color: #000000;
    }
}

.conf2-radio {
    position: relative;
    display: block;
    font-size: 14px;
    line-height: 1.5;
    padding-left: 28px;
    padding-top: 2px;
    margin-bottom: 5px;

    &:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 5px;
        width: 16px;
        height: 16px;
        border: 1px solid #EBEBEB;
    }

    &:hover {
        cursor: pointer;
    }

    &.selected {
        &:after {
            content: '';
            display: block;
            position: absolute;
            left: 0px;
            top: 5px;
            width: 19px;
            height: 12px;
            border-left: 5px solid #2BC4A7;
            border-bottom: 5px solid #2BC4A7;
            transform: rotate(-45deg);
        }
    }
}

.qr-text {
    margin: 20px;
}

.conf2-radio-info-text {
    margin-bottom: 15px;
}

textarea {
    height: 48px;
    padding: 2px 11px;
    line-height: 1.7;
    margin-top: -10px;
    margin-bottom: 15px;
}

strong {
    font-weight: 700;
}

#configurator .device-error {
    padding: 20px;

    h4 {
        margin-bottom: 25px;
    }

    p {
        padding-left: 30px;
        padding-top: 60px;
        font-size: 15px;
        max-width: calc(100% - 280px);
    }
}

.conf2-save-image {
    background: url("/gfx/conf2/ar-save-modal.png") no-repeat center center;
    background-size: cover;
}
</style>
